<template>
  <div class="support">
    <div class="container">
      <div class="support__header">
        <div class="support__header-left">
          <h1 class="support__header-left-title">{{ $t("support.title") }}</h1>
          <LinkIcon
            :href="
              locale === 'ru'
                ? '/static/docs/account_instruction.pdf'
                : '/static/docs/account_instruction_en.pdf'
            "
            icon="doc"
            class="profile__data-block-form-btn support__header-left-link"
            target="_blank"
          >
            {{ $t("support.instruction") }}
          </LinkIcon>
        </div>
        <div class="support__header-right">
          <p class="support__header-right-text">
            {{ $t("support.callcentreTitle") }}
          </p>
          <a href="tel:+78007073799" class="support__header-right-number">
            8 (800) 707-37-99
          </a>
          <a
            href="mailto:suplk@expocentr.ru"
            class="support__header-right-email"
          >
            suplk@expocentr.ru
          </a>
        </div>
      </div>
      <div class="support__header-action">
        <div class="support__header-action-search">
          <SearchField
            :placeholder="$t('support.searchPlaceholder')"
            v-model="search"
          />
        </div>
        <div class="support__header-action-btn">
          <PrimaryButton
            class="support__header-action-btn-link"
            @click="$modal.show('feedback-modal')"
          >
            {{ $t("support.askQuestionBtn") }}
          </PrimaryButton>
        </div>
      </div>
      <div class="support__faq">
        <Accordion v-for="(item, i) in searchedResults" :key="i">
          <template #header>
            {{ item.title }}
          </template>

          <div v-html="item.content"></div>
        </Accordion>

        <div
          class="support__faq-noresults"
          v-if="!searchedResults.length && search"
        >
          {{ $t("support.nothingFound") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Accordion,
  PrimaryButton,
  LinkIcon,
  SearchField,
  Video
} from "@v2/shared/ui/components";
import { i18n } from "@v2/shared/config";
import { qaRu, qaEng } from "../model/questionAnswer";

export default {
  components: {
    LinkIcon,
    SearchField,
    PrimaryButton,
    Accordion,
    Video
  },

  data: () => ({
    search: ""
  }),

  computed: {
    locale() {
      return i18n.locale;
    },
    qa() {
      return this.locale === "ru" ? qaRu : qaEng;
    },
    searchedResults() {
      const search = this.search.trim().toLowerCase();
      return this.qa.filter(x => x.title.toLowerCase().indexOf(search) !== -1);
    }
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.support {
  width: 100%;

  &__header {
    display: flex;
    justify-content: space-between;
    padding: 39px 0 52px 0;

    @include respond-down(md) {
      flex-direction: column;
      padding: 24px 0 24px 0;
    }

    &-left {
      width: 50%;

      @include respond-down(md) {
        width: 100%;
      }

      &-title {
        @include h1();
        margin: 0 0 34px 0;

        @include respond-down(md) {
          font-size: 20px;
          margin: 0 0 24px 0;
        }
      }

      &-link {
        margin: 0 0 0 0;
        display: block;

        .link-icon {
          @include respond-down(md) {
            align-items: flex-start;
          }
        }

        .link-icon__text {
          color: #6d7179;

          @include respond-down(md) {
            font-size: 12px;
          }
        }
      }
    }

    &-right {
      width: 50%;
      display: flex;
      flex-direction: column;

      @include respond-down(lg) {
        width: 40%;
      }

      @include respond-down(md) {
        width: 100%;
      }

      &-text {
        font-size: 13px;
        line-height: 1.54;
        color: #000000;
        margin: 20px 0 13px 0;

        @include respond-down(md) {
          font-size: 12px;

          margin: 24px 0 8px 0;
        }
      }

      &-number {
        font-family: Roboto, serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
        text-decoration: none;

        color: #505050;

        margin: 0 0 3px 0;

        @include respond-down(md) {
          font-size: 14px;
        }
      }

      &-email {
        font-family: Roboto, serif;
        font-size: 13px;

        line-height: 1.54;

        color: #6d7179;
        margin: 0;
      }
    }

    &-action {
      display: flex;
      justify-content: space-between;

      padding: 0 0 24px 0;

      @include respond-down(md) {
        flex-direction: column-reverse;
        padding: 0 0 16px 0;
      }

      &-search {
        width: 50%;

        @include respond-down(md) {
          width: 100%;
        }

        .search-field {
          width: 100%;
          max-width: 440px;
        }
      }

      &-btn {
        width: 50%;

        @include respond-down(lg) {
          width: 40%;
        }

        @include respond-down(md) {
          width: 100%;

          margin: 0 0 24px 0;
        }

        &-link {
          align-self: flex-start;
        }
      }
    }
  }

  &__faq {
    margin-bottom: 40px;
    &-noresults {
      @include description();

      padding-top: 30px;
      padding-bottom: 10px;
    }

    @include respond-down(md) {
      margin: 0 -16px;

      .accordion__header {
        padding: 15px 16px 15px 16px;
        align-items: flex-start;

        svg {
          flex-shrink: 0;
          margin-left: 10px;
        }
      }
    }

    &-btn-more {
      margin: 42px 0 0 0;
      display: block;

      @include respond-down(md) {
        margin: 24px 0 0 16px;
        align-items: flex-start;
      }
    }
  }
}
</style>
